
const BERRI_USER_TOKEN = "BERRI_USER_TOKEN";
const BERRI_THEME_VARIANT = "BERRI_THEME_VARIANT";
const BERRI_USER_AUTH_DATA = "BERRI_USER_AUTH_DATA";
// const SERVER_BASE_URL = "http://localhost:3000/v1/user";
// const SERVER_BASE_URL = "https://dropcut.onrender.com/v1/user";
const SERVER_BASE_URL = "https://berri-api.vercel.app/v1/user";

export const CONSTANTS = {BERRI_USER_TOKEN, BERRI_USER_AUTH_DATA, BERRI_THEME_VARIANT, SERVER_BASE_URL};
